import { darken, styled } from '@mui/material';
import { DatagridConfigurable } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils/getColumnStyle';

export const DatagridStyled = styled(DatagridConfigurable)(({ theme }) => ({
  '& .RaDatagrid-table': {
    borderCollapse: 'separate',
    borderSpacing: 0,
    cursor: 'default',
  },
  '& .RaDatagrid-headerCell': {
    textAlign: 'right',
    verticalAlign: 'middle',
    padding: '6px 16px',
  },
  '.RaDatagrid-rowCell': {
    padding: '6px 16px',
    verticalAlign: 'middle',
  },

  '& .column-name': {
    ...getColumnStyle(400),
    textAlign: 'left',
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: 'inherit',
    boxShadow: '4px 0 8px rgba(0,0,0,0.08)',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'wrap',
  },

  '& .RaDatagrid-headerCell.column-name': {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: theme.palette.tableHead,
    boxShadow: '4px 0 8px rgba(0,0,0,0.08)',
  },

  '& .column-currencyCode': {
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  '& .column-undefined': {
    minWidth: '168px',
  },

  '& .row-company-0': {
    backgroundColor: '#FFFDE7',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#FFFDE7', 0.025)}`,
    },
  },
  '& .row-company-1': {
    backgroundColor: '#E8F5E9',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#E8F5E9', 0.025)}`,
    },
  },

  '& .row-provider-0': {
    backgroundColor: '#FFAF3A',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#FFAF3A', 0.05)}`,
    },
  },
  '& .row-provider-1': {
    backgroundColor: '#FFB74D',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#FFB74D', 0.05)}`,
    },
  },
  '& .row-provider-2': {
    backgroundColor: '#FFC267',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#FFC267', 0.05)}`,
    },
  },
  '& .row-provider-3': {
    backgroundColor: '#FFCC80',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#FFCC80', 0.05)}`,
    },
  },
  '& .row-provider-4': {
    backgroundColor: '#FFD699',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#FFD699', 0.05)}`,
    },
  },
  '& .row-provider-5': {
    backgroundColor: '#FFE0B2',
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${darken('#FFE0B2', 0.05)}`,
    },
  },

  '& tr.MuiTableRow-hover:hover': {
    backgroundColor: '#f5f5f5',
  },
}));
